<template>
  <div
    class="bg-dark"
    :class="[viewStore.isMobile ? 'reference-mobile' : 'reference']"
  >
    <div class="d-flex justify-content-center">
      <h1 class="header-title">Referenzen</h1>
    </div>

    <!-- Horizontal Scroll -->

    <div class="container py-3 mt-4" style="border-top: 1px solid #454545">
      <!-- <div class="row row-cols-md-3 pb-5">
        <div
          v-for="reference in references[viewStore.selfOrCompany]"
          :key="reference"
          class="col" :class="[viewStore.isMobile ? 'py-0' : 'py-3']"
        >
          <li class="card  " :class="[viewStore.isMobile ? '' : 'lift-effect']">
            <a
              data-bs-toggle="collapse"
              :data-bs-target="'#collapse' + reference.id"
              aria-expanded="false"
              :aria-controls="'collapse' + reference.id"
            >
              <img
                :src="reference.image"
                class="img-fluid rounded-3"
                alt="..."
              />
            </a>

            <div
              :id="'collapse' + reference.id"
              class="accordion-collapse collapse"
              :aria-labelledby="'heading' + reference.id"
              data-bs-parent="#accordionExample"
            >
              <div class="accordion-body rounded-3 rounded-top-0 p-4 lh-base">
                {{ reference.quote }}

                <div class="pt-2">
                  <hr />
                  <div class="work-ref fw-bold">Laura Seiler</div>
                  <div>Work: Podcasts, Hörbuch, App</div>
                </div>
              </div>
            </div>
          </li>
        </div>
      </div> -->

      <!-- References -->
      <div
        id="accordionExample"
        class="row row-cols-md-3 row-cols-1 pb-5 accordion"
        :class="[viewStore.isMobile ? 'pt-0' : 'pt-4']"
      >
        <div class="col" :class="[viewStore.isMobile ? 'py-0' : 'py-3']">
          <div class="card" :class="[viewStore.isMobile ? '' : 'lift-effect']">
            <a
              data-bs-toggle="collapse"
              data-bs-target="#collapse1"
              aria-expanded="true"
              aria-controls="collapse1"
            >
              <img
                src="../assets/images/laura.jpeg"
                class="img-fluid rounded-3"
                alt="..."
              />
            </a>

            <div
              id="collapse1"
              class="accordion-collapse collapse show"
              aria-labelledby="heading1"
              data-bs-parent="#accordionExample"
              data-bs-toggle="collapse"
              data-bs-target="#collapse1"
              aria-controls="collapse1"
            >
              <div class="accordion-body rounded-3 rounded-top-0 p-4 lh-base">
                VAP steht für die perfekt Soundqualität und die beste
                Tonatmosphäre! Ich bin sehr zufrieden mit der Zusammenarbeit und
                all den Projekten, in denen wir zusammengearbeitet haben. Durch
                Know-How und Expertise bekommen Hörbuch bis Podcast und
                Meditationen immer den Extra-Schliff. Sie lassen alles super
                klingen.
                <div class="pt-2">
                  <hr />
                  <div class="work-ref fw-bold">Laura Seiler</div>
                  <div>Work: Podcasts, Hörbuch, App</div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="col" :class="[viewStore.isMobile ? 'py-0' : 'py-3']">
          <div class="card" :class="[viewStore.isMobile ? '' : 'lift-effect']">
            <a
              data-bs-toggle="collapse"
              data-bs-target="#collapse2"
              aria-expanded="false"
              aria-controls="collapse2"
            >
              <img
                src="../assets/images/chris.jpg"
                class="img-fluid rounded-3"
                alt="..."
              />
            </a>

            <div
              id="collapse2"
              class="accordion-collapse collapse"
              aria-labelledby="heading2"
              data-bs-parent="#accordionExample"
              data-bs-toggle="collapse"
              data-bs-target="#collapse2"
              aria-controls="collapse2"
            >
              <div class="accordion-body rounded-3 rounded-top-0 p-4 lh-base">
                Die Zusammenarbeit mit VAP ist super und macht mega Spaß! Jakob
                gibt konstruktives Feedback, dass ich in den Podcast einfließen
                lassen kann. Die Zusammenarbeit hat meine internen Prozesse
                verbessert. Ich freue mich auf die zukünftige Partnerschaft!
                <div class="pt-2">
                  <hr />
                  <div class="work-ref fw-bold">Chris Bloom</div>
                  <div>Work: Podcast, Meditationen, Videoformate</div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="col" :class="[viewStore.isMobile ? 'py-0' : 'py-3']">
          <div class="card" :class="[viewStore.isMobile ? '' : 'lift-effect']">
            <a
              data-bs-toggle="collapse"
              data-bs-target="#collapse3"
              aria-expanded="false"
              aria-controls="collapse3"
            >
              <img
                src="../assets/images/janey.png"
                class="img-fluid rounded-3"
                alt="..."
              />
            </a>

            <div
              id="collapse3"
              class="accordion-collapse collapse"
              aria-labelledby="heading3"
              data-bs-parent="#accordionExample"
              data-bs-toggle="collapse"
              data-bs-target="#collapse3"
              aria-controls="collapse3"
            >
              <div class="accordion-body rounded-3 rounded-top-0 p-4 lh-base">
                Ohne Jakob wäre mein Podcast nicht was er ist. Ich hatte mich
                alleine mit dem Start sehr schwer getan. Die Hilfe, die
                Checklisten und Telefonate, dabei seine unfassbar nette und
                liebe Art, das ist wirklich einzigartig und so nicht woanders zu
                finden. Jakob war bisher immer für mich da, wenn ich Fragen
                hatte. Er kommt mit neuen Ideen auf mich zu und man merkt in
                allem, dass er liebt, was er tut. Dabei geht es ihm niemals
                einfach darum, einen Job abzuhaken und Geld zu verdienen, er
                brennt dafür, seine Leute voran zu bringen. Diese Kombination an
                Können und unglaublich sympathischer Art, gibt es nur bei ihm.
                Du brauchst gar nicht woanders suchen.
                <div class="pt-2">
                  <hr />
                  <div class="work-ref fw-bold">Dr. Janey May</div>
                  <div>Work: Podcast</div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="col" :class="[viewStore.isMobile ? 'py-0' : 'py-3']">
          <div class="card" :class="[viewStore.isMobile ? '' : 'lift-effect']">
            <a
              data-bs-toggle="collapse"
              data-bs-target="#collapse4"
              aria-expanded="false"
              aria-controls="collapse4"
            >
              <img
                src="../assets/images/kati.jpeg"
                class="img-fluid rounded-3"
                alt="..."
              />
            </a>

            <div
              id="collapse4"
              class="accordion-collapse collapse"
              aria-labelledby="heading4"
              data-bs-parent="#accordionExample"
              data-bs-toggle="collapse"
              data-bs-target="#collapse4"
              aria-controls="collapse4"
            >
              <div class="accordion-body rounded-3 rounded-top-0 p-4 lh-base">
                VAP hat mir bereits zu Beginn meines Podcasts "Mit Trauma
                wachsen" beratend zur Seite gestanden und mir gutes Equipment
                empfohlen. Mittlerweile bin ich echt gut ausgestattet! Da ich
                viele verschiedene Projekte zeitgleich mache, war es mir
                wichtig, meine knappe Zeit nur mit der Aufnahme und nicht dem
                ganzen drum herum zu verbringen. VAP kümmert sich, dass die
                Folge bei allen Anbietern erscheint, erstellt Audioschnipsel für
                Social media & macht natürlich alles so, dass die Folge gut auf
                den Ohren ankommt. Jakob hat mich da prima mit der Intro-Musik
                beraten, kann auch aus verkacktem Sound noch jede Menge
                rausholen und ist einfach sehr zuverlässig, auch wenn ich
                manchmal in letzter Minute liefere. Ich bin super zufrieden und
                empfehle Jakob gerne weiter!
                <div class="pt-2">
                  <hr />
                  <div class="work-ref fw-bold">Kati Bohnet</div>
                  <div>Work: Podcast, Hörspiel</div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="col" :class="[viewStore.isMobile ? 'py-0' : 'py-3']">
          <div class="card" :class="[viewStore.isMobile ? '' : 'lift-effect']">
            <a
              data-bs-toggle="collapse"
              data-bs-target="#collapse5"
              aria-expanded="false"
              aria-controls="collapse5"
            >
              <img
                src="../assets/images/kristin_graf.jpg"
                class="img-fluid rounded-3"
                alt="..."
              />
            </a>

            <div
              id="collapse5"
              class="accordion-collapse collapse"
              aria-labelledby="heading5"
              data-bs-parent="#accordionExample"
              data-bs-toggle="collapse"
              data-bs-target="#collapse5"
              aria-controls="collapse5"
            >
              <div class="accordion-body rounded-3 rounded-top-0 p-4 lh-base">
                Ich bin so froh, dass ich VAP gefunden habe, denn nach einer
                sehr teuren und enttäuschenden Arbeit eines anderen Tonstudios
                waren sie wirklich meine Rettung! Die Arbeit im Tonstudio mit
                Jakob war super angenehm und nett, und das Endergebnis ist genau
                so, wie ich es mir gewünscht hatte! VAP arbeitet zuverlässig,
                schnell, freundlich und kompetent. Was will man mehr?
                <div class="pt-2">
                  <hr />
                  <div class="work-ref fw-bold">Kristin Graf</div>
                  <div>Work: Podcast, Hörbuch, App</div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="col" :class="[viewStore.isMobile ? 'py-0' : 'py-3']">
          <div class="card" :class="[viewStore.isMobile ? '' : 'lift-effect']">
            <a
              data-bs-toggle="collapse"
              data-bs-target="#collapse6"
              aria-expanded="false"
              aria-controls="collapse6"
            >
              <img
                src="../assets/images/louisa.jpg"
                class="img-fluid rounded-3"
                alt="..."
              />
            </a>

            <div
              id="collapse6"
              class="accordion-collapse collapse"
              aria-labelledby="heading6"
              data-bs-parent="#accordionExample"
              data-bs-toggle="collapse"
              data-bs-target="#collapse6"
              aria-controls="collapse6"
            >
              <div class="accordion-body rounded-3 rounded-top-0 p-4 lh-base">
                Ich bin so dankbar mit VAP zu arbeiten. Durch das qualitative,
                kompetente Wissen und den Rund-um-Blick unterstützten sie mich
                nicht nur beim Schneiden sondern auch bei Fragen rund um
                Qualität, Technik und Neuerungen. Wenn etwas schief läufts sind
                sie da und unterstützten wo sie können. Super dankbar einfach
                nur!
                <div class="pt-2">
                  <hr />
                  <div class="work-ref fw-bold">Louisa Domhan</div>
                  <div>Work: Podcast</div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="col" :class="[viewStore.isMobile ? 'py-0' : 'py-3']">
          <div class="card" :class="[viewStore.isMobile ? '' : 'lift-effect']">
            <a
              data-bs-toggle="collapse"
              data-bs-target="#collapse7"
              aria-expanded="false"
              aria-controls="collapse7"
            >
              <img
                src="../assets/images/kiran.jpg"
                class="img-fluid rounded-3"
                alt="..."
              />
            </a>

            <div
              id="collapse7"
              class="accordion-collapse collapse"
              aria-labelledby="heading7"
              data-bs-parent="#accordionExample"
              data-bs-toggle="collapse"
              data-bs-target="#collapse7"
              aria-controls="collapse7"
            >
              <div class="accordion-body rounded-3 rounded-top-0 p-4 lh-base">
                Seit ein paar Monaten betreut VAP meinen Podcast. Seit dem
                steigen die Downloads deutlich. Ich freue mich sehr, war mir
                vorher nicht bewusst, dass die Qualität außerhalb des Inhaltes
                auch so wichtig ist. Die Zusammenarbeit mit VAP macht viel Spaß,
                sie arbeiten zeitnah, Hand in Hand und super mit meinem Team
                zusammen. Also vollste Empfehlung für Jakob und sein Team und
                ich freue mich auf alles was noch kommt und welche Ideen ich mit
                euch umsetzten werde.
                <div class="pt-2">
                  <hr />
                  <div class="work-ref fw-bold">Kiran Deuretzbacher</div>
                  <div>Work: Podcast</div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="col" :class="[viewStore.isMobile ? 'py-0' : 'py-3']">
          <div class="card" :class="[viewStore.isMobile ? '' : 'lift-effect']">
            <a
              data-bs-toggle="collapse"
              data-bs-target="#collapse8"
              aria-expanded="false"
              aria-controls="collapse8"
            >
              <img
                src="../assets/images/doctolib.jpg"
                class="img-fluid rounded-3"
                alt="..."
              />
            </a>

            <div
              id="collapse8"
              class="accordion-collapse collapse"
              aria-labelledby="heading8"
              data-bs-parent="#accordionExample"
              data-bs-toggle="collapse"
              data-bs-target="#collapse8"
              aria-controls="collapse8"
            >
              <div class="accordion-body rounded-3 rounded-top-0 p-4 lh-base">
                Die Zusammenarbeit mit Jakob war klasse! Wir haben gemeinsam mit
                ihm einen internen Unternehmenspodcast zur Vermittlung von
                Lerninhalten & Best Practices etabliert. Dank Jakob konnten wir
                ein attraktives und professionelles Format schaffen, dass
                parallel zum Tagesgeschäft gern konsumiert wird. Jakob hat uns
                effektiv beim Set-Up unseres Podcasts beraten - von der
                Hardwarebeschaffung bis zur Durchführung - und uns aktiv
                Feedback zur Podcastdurchführung gegeben, wodurch sich auch
                unsere Speaker verbessern konnten. Darüber hinaus hat er dafür
                gesorgt, dass unsere Podcastaufnahmen auf Studio-Niveau
                bearbeitet wurden. Wir möchten die Zusammenarbeit mit Jakob
                wärmsten empfehlen, insbesondere dann, wenn man an einer sehr
                professionellen, pragmatischen und werschätzenden Zusammenarbeit
                interessiert ist!
                <div class="pt-2">
                  <hr />
                  <div class="work-ref fw-bold">
                    Joshua Flügel (Sales Development)
                  </div>
                  <div>Work: Corporate Podcast</div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="col" :class="[viewStore.isMobile ? 'py-0' : 'py-3']">
          <div class="card" :class="[viewStore.isMobile ? '' : 'lift-effect']">
            <a
              data-bs-toggle="collapse"
              data-bs-target="#collapse9"
              aria-expanded="false"
              aria-controls="collapse9"
            >
              <img
                src="../assets/images/trend-raider.jpeg"
                class="img-fluid rounded-3"
                alt="..."
              />
            </a>

            <div
              id="collapse9"
              class="accordion-collapse collapse"
              aria-labelledby="heading9"
              data-bs-parent="#accordionExample"
              data-bs-toggle="collapse"
              data-bs-target="#collapse9"
              aria-controls="collapse9"
            >
              <div class="accordion-body rounded-3 rounded-top-0 p-4 lh-base">
                Die Zusammenarbeit mit VAP ist zu jeder Zeit unkompliziert und
                sehr sympathisch. Egal ob Produktion, Marketing oder Beratung -
                wir fühlen uns immer sehr gut abgeholt und supportet. Dabei ist
                die Qualität der Ergebnisse immer on point.

                <div class="pt-2">
                  <hr />
                  <div class="work-ref fw-bold">Lene von TrendRaider</div>
                  <div>Work: Corporate Podcast</div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="col" :class="[viewStore.isMobile ? 'py-0' : 'py-3']">
          <div class="card" :class="[viewStore.isMobile ? '' : 'lift-effect']">
            <a
              data-bs-toggle="collapse"
              data-bs-target="#collapse10"
              aria-expanded="false"
              aria-controls="collapse10"
            >
              <img
                src="../assets/images/pfoten.jpg"
                class="img-fluid rounded-3"
                alt="..."
              />
            </a>

            <div
              id="collapse10"
              class="accordion-collapse collapse"
              aria-labelledby="heading10"
              data-bs-parent="#accordionExample"
              data-bs-toggle="collapse"
              data-bs-target="#collapse10"
              aria-controls="collapse10"
            >
              <div class="accordion-body rounded-3 rounded-top-0 p-4 lh-base">
                Wir arbeiten schon von der ersten Folge an mit VAP zusammen und
                sind riesig froh über die technische Unterstützung. So haben wir
                den Kopf frei, können uns auf die Inhalte konzentrieren und
                sollte doch mal irgendwas nicht klappen, ist Jakob immer sofort
                dabei und findet Lösungen. Danke für diese wunderbare, fröhliche
                und produktive Zusammenarbeit! Kate, Madita und das Team von
                Kosmos Hund!
                <div class="pt-2">
                  <hr />
                  <div class="work-ref fw-bold">
                    Madita von Hülsen & Kate Kitchenham
                  </div>
                  <div>Work: Podcast, Audio Ratgeber</div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="col" :class="[viewStore.isMobile ? 'py-0' : 'py-3']">
          <div class="card" :class="[viewStore.isMobile ? '' : 'lift-effect']">
            <a
              data-bs-toggle="collapse"
              data-bs-target="#collapse11"
              aria-expanded="false"
              aria-controls="collapse11"
            >
              <img
                src="../assets/images/geil.jpeg"
                class="img-fluid rounded-3"
                alt="..."
              />
            </a>

            <div
              id="collapse11"
              class="accordion-collapse collapse"
              aria-labelledby="heading11"
              data-bs-parent="#accordionExample"
              data-bs-toggle="collapse"
              data-bs-target="#collapse11"
              aria-controls="collapse11"
            >
              <div class="accordion-body rounded-3 rounded-top-0 p-4 lh-base">
                <div class="pt-2">
                  <hr />
                  <div class="work-ref fw-bold">Lena Moroselia</div>
                  <div>Work: Podcast</div>
                </div>
              </div>
            </div>
          </div>
        </div>

        <div class="col" :class="[viewStore.isMobile ? 'py-0' : 'py-3']">
          <div class="card" :class="[viewStore.isMobile ? '' : 'lift-effect']">
            <a
              data-bs-toggle="collapse"
              data-bs-target="#collapse12"
              aria-expanded="false"
              aria-controls="collapse12"
            >
              <img
                src="../assets/images/heinlein.jpeg"
                class="img-fluid rounded-3"
                alt="..."
              />
            </a>

            <div
              id="collapse12"
              class="accordion-collapse collapse"
              aria-labelledby="heading12"
              data-bs-parent="#accordionExample"
              data-bs-toggle="collapse"
              data-bs-target="#collapse12"
              aria-controls="collapse12"
            >
              <div class="accordion-body rounded-3 rounded-top-0 p-4 lh-base">
                Ohne Jakob wären Evelyn und ich völlig aufgeschmissen. Unser
                Podcast müsste ungeschnitten und mit schlechter Sound-Qualität
                veröffentlich werden – und glaubt mir: Das möchte keiner hören.
                Dank Jakob haben wir das Gefühl, dass wir sogar etwas
                intelligenter rüberkommen als wir eigentlich sind. Seit Jakob
                unsere Folgen schneidet behaupten wir auch, dass wir Abitur
                haben. Danke dafür. Neben der fachlichen Kompetenz kommt es
                Evelyn und mir vor allem auf die menschliche an. Und auch hier
                erreicht Jakob volle Punktzahl. Würde ich nochmal heiraten, wäre
                Jakob mein Auserwählter.
                <div class="pt-2">
                  <hr />
                  <div class="work-ref fw-bold">Basti Heinlein</div>
                  <div>Work: Podcast Host</div>
                </div>
              </div>
            </div>
          </div>
        </div>

        <div class="col" :class="[viewStore.isMobile ? 'py-0' : 'py-3']">
          <div class="card" :class="[viewStore.isMobile ? '' : 'lift-effect']">
            <a
              data-bs-toggle="collapse"
              data-bs-target="#collapse13"
              aria-expanded="false"
              aria-controls="collapse13"
            >
              <img
                src="../assets/images/saskia.jpg"
                class="img-fluid rounded-3"
                alt="..."
              />
            </a>

            <div
              id="collapse13"
              class="accordion-collapse collapse"
              aria-labelledby="heading13"
              data-bs-parent="#accordionExample"
              data-bs-toggle="collapse"
              data-bs-target="#collapse13"
              aria-controls="collapse13"
            >
              <div class="accordion-body rounded-3 rounded-top-0 p-4 lh-base">
                Ohne Jakob würde es meinen Podcast und mein heißgeliebtes
                Hörspiel zu Wilma Wolkenkopf schlichtweg nicht geben. Er setzt
                meine Ideen und Inhalte auf wunderbar authentische und
                professionelle Weise um, arbeitet unheimlich verlässlich,
                bestärkt meine Arbeit und hilft durch hier und da eine kleine
                Erinnerung meinem chaotischen Gehirn. Ich fühle mich unheimlich
                gut betreut.
                <div class="pt-2">
                  <hr />
                  <div class="work-ref fw-bold">Saskia Niechzial</div>
                  <div>Work: Podcast, Hörspiel</div>
                </div>
              </div>
            </div>
          </div>
        </div>

        <div class="col" :class="[viewStore.isMobile ? 'py-0' : 'py-3']">
          <div class="card" :class="[viewStore.isMobile ? '' : 'lift-effect']">
            <a
              data-bs-toggle="collapse"
              data-bs-target="#collapse14"
              aria-expanded="false"
              aria-controls="collapse14"
            >
              <img
                src="../assets/images/anne_bucher.png"
                class="img-fluid rounded-3"
                alt="..."
              />
            </a>

            <div
              id="collapse14"
              class="accordion-collapse collapse"
              aria-labelledby="heading14"
              data-bs-parent="#accordionExample"
              data-bs-toggle="collapse"
              data-bs-target="#collapse14"
              aria-controls="collapse14"
            >
              <div class="accordion-body rounded-3 rounded-top-0 p-4 lh-base">
                Die Zusammenarbeit mit VAP ist einfach nur genial! Nicht nur,
                dass mein Podcast eine ganz neue Qualität erreicht hat, sondern
                es war auch noch nie so einfach zu podcasten. Und ich bisher
                weit weniger professionell. Ich habe hier die für mich perfekte
                Kombi aus hochwertiger Umsetzung und professioneller Beratung
                gefunden. Ich weiß, dass ich mich mit allen Fragen und Ideen
                melden darf und gemeinsam nach pragmatischen Wegen für neue
                Ideen gesucht wird. Für mich nicht nur qualitativ das
                Nonplusultra, sondern auch eine extreme Entlastung!
                <div class="pt-2">
                  <hr />
                  <div class="work-ref fw-bold">Anne Bucher</div>
                  <div>Work: Podcast</div>
                </div>
              </div>
            </div>
          </div>
        </div>

        <div class="col" :class="[viewStore.isMobile ? 'py-0' : 'py-3']">
          <div class="card" :class="[viewStore.isMobile ? '' : 'lift-effect']">
            <a
              data-bs-toggle="collapse"
              data-bs-target="#collapse-15"
              aria-expanded="false"
              aria-controls="collapse-15"
            >
              <img
                src="../assets/images/conners_kestel.jpeg"
                class="img-fluid rounded-3"
                alt="..."
              />
            </a>

            <div
              id="collapse-15"
              class="accordion-collapse collapse"
              aria-labelledby="heading-15"
              data-bs-parent="#accordionExample"
              data-bs-toggle="collapse"
              data-bs-target="#collapse-15"
              aria-controls="collapse-15"
            >
              <div class="accordion-body rounded-3 rounded-top-0 p-4 lh-base">
                Jakob ist der beste! Jakob und sein Team macht nicht nur einen
                richtig guten Job, sondern blickt immer über den Tellerrand
                hinaus. Ich weiß nicht, ob er das hier gerne selbst lesen
                möchte, aber ich habe Jakob schon so oft nach Feierabend noch um
                weitere Gefallen gebeten, und er hat mir noch nie einen Wunsch
                abgeschlagen. 😃 Ich liebe die Flexibilität und die
                Professionalität und dass wir über jedes Problem(chen) offen
                reden können und immer beste Lösungen finden! Die Zusammenarbeit
                mit Jakob finde ich so super, dass ich ihn schon an Kolleginnen
                aus dem Bereich Podcast mit bestem Gewissen weiter empfohlen
                habe.
                <div class="pt-2">
                  <hr />
                  <div class="work-ref fw-bold">
                    Kristin Conners & Lisa Kestel
                  </div>
                  <div>Work: Podcast</div>
                </div>
              </div>
            </div>
          </div>
        </div>

        <div class="col" :class="[viewStore.isMobile ? 'py-0' : 'py-3']">
          <div class="card" :class="[viewStore.isMobile ? '' : 'lift-effect']">
            <a
              data-bs-toggle="collapse"
              data-bs-target="#collapse-16"
              aria-expanded="false"
              aria-controls="collapse-16"
            >
              <img
                src="../assets/images/katja_staeheli.jpg"
                class="img-fluid rounded-3"
                alt="..."
              />
            </a>

            <div
              id="collapse-16"
              class="accordion-collapse collapse"
              aria-labelledby="heading-16"
              data-bs-parent="#accordionExample"
              data-bs-toggle="collapse"
              data-bs-target="#collapse-16"
              aria-controls="collapse-16"
            >
              <div class="accordion-body rounded-3 rounded-top-0 p-4 lh-base">
                Über ein Jahr hatte ich die Podcast Idee auf dem Tisch. Doch
                konnte Sie nicht in die Umsetzung bringen, weil mir ein Team
                gefehlt hat, welches mich begleitet und mit mir den Prozess
                durchläuft, in die Sichtbarkeit zu kommen. Als ich Jakob
                gefunden habe, wurde es leicht für mich, die Schritte zu gehen.
                So haben wir vieles gemeinsam besprochen und ich konnte mich in
                meinem Podcast zügig positionieren. Besonders schätze ich, dass
                meine Fragen und Unsicherheiten immer Raum haben, schnell zu
                einer Schlussfolgerung zu kommen, damit ich in meiner Produktion
                nicht steckenbleibe. Ein Podcast zu produzieren ist eine heiden
                Arbeit. Das ist am Anfang gar nicht so sichtbar. Ich bin sehr
                froh, dass ich mir tatkräftige und sehr professionelle Hilfe
                geholt habe, denn alleine hätte ich das nicht gemanaged. Ich bin
                besonders dankbar, dass die Jungs auf saubere Abläufe setzen und
                sich somit eine Routine etablieren kann, die auch mir hilft,
                mich in diesem neuen Segment zurechtzufinden. Ich danke dir
                vielmals Jakob und freue mich auf viele weitere Folgen
                gemeinsamer Zusammenarbeit.
                <div class="pt-2">
                  <hr />
                  <div class="work-ref fw-bold">Katja Stäheli</div>
                  <div>Work: Videopodcast, Meditationen</div>
                </div>
              </div>
            </div>
          </div>
        </div>

        <div class="col" :class="[viewStore.isMobile ? 'py-0' : 'py-3']">
          <div class="card" :class="[viewStore.isMobile ? '' : 'lift-effect']">
            <a
              data-bs-toggle="collapse"
              data-bs-target="#collapse-17"
              aria-expanded="false"
              aria-controls="collapse-17"
            >
              <img
                src="../assets/images/jane_von_klee.jpeg"
                class="img-fluid rounded-3"
                alt="..."
              />
            </a>

            <div
              id="collapse-17"
              class="accordion-collapse collapse"
              aria-labelledby="heading-17"
              data-bs-parent="#accordionExample"
              data-bs-toggle="collapse"
              data-bs-target="#collapse-17"
              aria-controls="collapse-17"
            >
              <div class="accordion-body rounded-3 rounded-top-0 p-4 lh-base">
                Jakob kann ganz klar zaubern. Aus "Hmm, der Ton ist ganz okay"
                macht er ein fettes "Bäm!" - immer mit dem richtigen Ohr fürs
                Detail. Außerdem schätze ich sehr, wie er von sich aus mitdenkt.
                Zwischen den Folgen bekomme ich richtig gute Ratschläge von ihm
                und habe das Gefühl, dass er aufrichtig am Erfolg meines
                Podcasts interessiert ist. Ich bin froh, Jakob an meiner Seite
                zu wissen!
                <div class="pt-2">
                  <hr />
                  <div class="work-ref fw-bold">Jane von Klee</div>
                  <div>Work: Podcast</div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <!-- Erstgespräch -->
    <div class="text-center fs-3 text-white fw-bold">
      <div v-if="viewStore.selfActive" class="pb-2">
        <h1 class="reference-cta-header">Kontakt aufnehmen</h1>
      </div>
      <div v-else class="pb-4">
        <h1 class="reference-cta-header">
          Als Unternehmen teilen, <br />was Ihr als Unternehmen teilt
        </h1>
      </div>

      <a
        id="kontakt-podcast"
        class="mt-5 btn btn-primary btn-lg px-4"
        href="https://calendly.com/voiceart-productions/erstgespraech"
        target="_blank"
      >
        <span v-if="viewStore.selfActive">Erzähl uns von dir</span>
        <span v-else>Erzählt uns von euch</span>
      </a>
      <div class="cta-sub pt-4">
        <div v-if="viewStore.selfActive">
          Jetzt kostenloses Erstgespräch buchen
        </div>
        <div v-else>Jetzt kostenloses Erstgespräch vereinbaren</div>
      </div>
    </div>
  </div>
</template>

<script setup>
import { useViewStore } from "../stores/ViewStore";

const viewStore = useViewStore();

const router = useRouter();
const currentRoute = router.currentRoute.value.path;

const references = ref({
  self: [
    {
      id: "1",
      imageLink: "@/assets/images/laura.jpeg",
      quote:
        "VAP steht für die perfekt Soundqualität und die beste Tonatmosphäre! Ich bin sehr zufrieden mit der Zusammenarbeit und all den Projekten, in denen wir zusammengearbeitet haben. Durch Know-How und Expertise bekommen Hörbuch bis Podcast und Meditationen immer den Extra-Schliff. Sie lassen alles super klingen.",
      author: "Laura Seiler",
      work: "Work: Podcasts, Hörbuch, App",
    },
    {
      id: "2",
      image: "../assets/images/chris.jpg",
      quote:
        "Die Zusammenarbeit mit VAP ist super und macht mega Spaß! Jakob gibt konstruktives Feedback, dass ich in den Podcast einfließen lassen kann. Die Zusammenarbeit hat meine internen Prozesse verbessert. Ich freue mich auf die zukünftige Partnerschaft!",
      author: "Chris Bloom",
      work: "Work: Podcast, Meditationen, Videoformate",
    },
    {
      id: "3",
      image: "../assets/images/janey.png",
      quote:
        "Ohne Jakob wäre mein Podcast nicht was er ist. Ich hatte mich alleine mit dem Start sehr schwer getan. Die Hilfe, die Checklisten und Telefonate, dabei seine unfassbar nette und liebe Art, das ist wirklich einzigartig und so nicht woanders zu finden. Jakob war bisher immer für mich da, wenn ich Fragen hatte. Er kommt mit neuen Ideen auf mich zu und man merkt in allem, dass er liebt, was er tut. Dabei geht es ihm niemals einfach darum, einen Job abzuhaken und Geld zu verdienen, er brennt dafür, seine Leute voran zu bringen. Diese Kombination an Können und unglaublich sympathischer Art, gibt es nur bei ihm. Du brauchst gar nicht woanders suchen.",
      author: "Dr. Janey May",
      work: "Work: Podcast",
    },
    {
      id: "4",
      image: "../assets/images/kati.jpeg",
      quote:
        'VAP hat mir bereits zu Beginn meines Podcasts "Mit Trauma wachsen" beratend zur Seite gestanden und mir gutes Equipment empfohlen. Mittlerweile bin ich echt gut ausgestattet! Da ich viele verschiedene Projekte zeitgleich mache, war es mir wichtig, meine knappe Zeit nur mit der Aufnahme und nicht dem ganzen drum herum zu verbringen. VAP kümmert sich, dass die Folge bei allen Anbietern erscheint, erstellt Audioschnipsel für Social media & macht natürlich alles so, dass die Folge gut auf den Ohren ankommt. Jakob hat mich da prima mit der Intro-Musik beraten, kann auch aus verkacktem Sound noch jede Menge rausholen und ist einfach sehr zuverlässig, auch wenn ich manchmal in letzter Minute liefere. Ich bin super zufrieden und empfehle Jakob gerne weiter!',
      author: "Kati Bohnet",
      work: "Work: Podcast, Hörspiel",
    },
  ],
  company: [],
});
</script>

<style scoped lang="scss">
.reference-mobile {
  padding-top: 8rem;
  padding-bottom: 8rem;
}
.reference {
  padding-top: 10rem;
  padding-bottom: 12rem;
}
.work-ref {
  color: rgb(255, 255, 255);
}

.reference-text {
  color: rgb(190, 190, 190);
}
.header-title {
  color: #fc4667;
  font-weight: 700;
  font-size: 3.5rem;
  /* background: linear-gradient(90deg, #fc4667 0%, #816cff 99%);
  -webkit-background-clip: text;
  -webkit-text-fill-color: transparent;
  width: fit-content; */
}

.card-body {
  min-height: 300px;
  min-width: 300px;
  margin-right: 5px;
}
.accordion-body {
  background-color: rgb(28, 28, 28);
  color: rgb(214, 214, 214);
}

/* * {
  box-sizing: border-box;
  padding: 0;
  margin: 0;
} */

.container {
  max-width: 1400px;
  padding: 0 15px;
  margin: 0 auto;
}

h2 {
  font-size: 32px;
  margin-bottom: 1em;
}

.cards {
  display: grid;
  grid-auto-columns: 100%;
  grid-column-gap: 10px;
  grid-auto-flow: column;
  padding: 25px 0px;
  list-style: none;
  overflow-x: scroll;
  scroll-snap-type: x mandatory;
}

.card {
  display: flex;
  flex-direction: column;
  padding: 20px;
  background: var(--white);
  border-radius: 12px;
  box-shadow: 0 5px 15px rgba(0, 0, 0, 15%);
  scroll-snap-align: start;
  transition: all 0.2s;
}

.card:hover {
  color: var(--white);
  background: var(--orange);
}

.card .card-title {
  font-size: 20px;
}

.card .card-content {
  margin: 20px 0;
  max-width: 85%;
}

.card .card-link-wrapper {
  margin-top: auto;
}

.card .card-link {
  display: inline-block;
  text-decoration: none;
  color: white;
  background: var(--orange);
  padding: 6px 12px;
  border-radius: 8px;
  transition: background 0.2s;
}

.card:hover .card-link {
  background: var(--darkorange);
}

.cards::-webkit-scrollbar {
  height: 12px;
}

.cards::-webkit-scrollbar-thumb,
.cards::-webkit-scrollbar-track {
  border-radius: 92px;
}

.cards::-webkit-scrollbar-thumb {
  background: var(--darkorange);
}

.cards::-webkit-scrollbar-track {
  background: var(--thumb);
}

@media (min-width: 500px) {
  .cards {
    grid-auto-columns: calc(50% - 10px);
    grid-column-gap: 20px;
  }
}

@media (min-width: 700px) {
  .cards {
    grid-auto-columns: calc(calc(100% / 3) - 20px);
    grid-column-gap: 30px;
  }
}

@media (min-width: 1100px) {
  .cards {
    grid-auto-columns: calc(calc(100% / 3) - 30px);
    grid-column-gap: 40px;
  }
}

#swipe-animation {
  position: relative;
  animation: myfirst 0.8s infinite;
  animation-direction: alternate;
}

@keyframes myfirst {
  0% {
    color: #fc4667 !important;
    left: 0px;
    top: 0px;
  }
  100% {
    color: black !important;
    left: -80px;
    top: 0px;
  }
}

.zoom {
  transition: transform 0.2s; /* Animation */
  margin: 0 auto;
}

.zoom:hover {
  transform: scale(
    1.15
  ); /* (150% zoom - Note: if the zoom is too large, it will go outside of the viewport) */
}

.lift-effect {
  will-change: transform;
  transition: transform 400ms;
}
.lift-effect:hover {
  transition: transform 150ms;
  transform: translateY(-20px);
}

.card:hover {
  cursor: pointer;
}

.cta-sub {
  color: #747474;
  font-size: 1.1rem;
  // font-weight: 400;
}
</style>
